import { DatePipe } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core'
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { QuoteService } from 'src/app/service/quote.service';

@Component({
  selector: 'quote-step2',
  templateUrl: 'quote-step2.component.html',
  styleUrls: ['quote-step2.component.css'],
})
export class QuoteStep2Component {
  @Input() screenWidth: number;
  @Input() currentStep: number;
  @Output() onNextStep: EventEmitter<number> = new EventEmitter();
  @Output() onPrevStep: EventEmitter<number> = new EventEmitter();

  vectorfilled: string = '/assets/external/vector3387-ynbm.svg'
  progressBarPath: string = '/assets/external/Progress-bar.svg'
  progressBarTransparentPath: string = '/assets/external/Progress-bar-transparent.svg'
  vectorUnFilled: string = '/assets/external/vector3387-ovts.svg'
  vectoralt: string = 'Vector3387'
  vectoralt4: string = 'Vector3387'
  ballPink1src: string = '/assets/external/basketball-resize.png'
  ballPink1alt: string = 'BallPink13179'
  towerGrey: string = '/assets/external/tower-resize.png'
  plusFilled: string = '/assets/external/plusFilled.png'
  ballPink1srcNew: string = '/assets/external/newbasketball-resize.png'
  ballBlueSmall: string = '/assets/external/ballbluesmall-resize.png'
  towerNew: string = '/assets/external/tower-new-resize.png'

  minDate: Date = new Date();
  maxDate: Date = new Date();
  birthDates: Date = new Date();
  dependencies: number = 0;
  dependenciesOlder: number = 0;
  birthdayInitialized: boolean = false;
  hasBirthdateError: boolean = false; // New property for error highlighting
  ageErrorMessage: string | null = null;
  days: number[] = [];
  months: number[] = [];
  years: number[] = [];

  submitted = false;
  stepTwoForm: FormGroup;
  lastYear: number = new Date().getFullYear()
  constructor(private quoteService: QuoteService,
    // private datePipe: DatePipe,
    private fb: FormBuilder) {
    this.createForm()
    // Al completar la fecha de nacimiento, la fila de dependientes hace un pequeno rebote (una sola vez) para que se vea que hay algo que llenar
    this.stepTwoForm.valueChanges.subscribe(() => this.checkBirthdateNudge());
  }

  nextStep(): void {
    console.log("this.birthDates: ", this.stepTwoForm.value);
    this.submitted = true;
    this.ageErrorMessage = null;
    // Compute birth date if day/month/year provided
    if (this.stepTwoForm.controls['selectedDay'].value && this.stepTwoForm.controls['monthSelected'].value && this.stepTwoForm.controls['yearSelected'].value) {
      this.birthDates = new Date(this.stepTwoForm.controls['yearSelected'].value, this.stepTwoForm.controls['monthSelected'].value - 1, this.stepTwoForm.controls['selectedDay'].value);
    }
    // Validate max age 84
    if (this.birthDates) {
      const age = this.calculateAge(this.birthDates);
      if (age > 84) {
        this.ageErrorMessage = 'Edad: 84 años edad máxima';
        this.hasBirthdateError = true;
        setTimeout(() => { this.hasBirthdateError = false; }, 3000);
        return;
      }
    }
    if (this.stepTwoForm.valid) {
      if (this.birthDates) {
        this.quoteService.quoteModel.applicantBirthdate = new DatePipe('en-US').transform(this.birthDates, 'yyyy-MM-dd');
      }
      this.quoteService.quoteModel.dependentCount = this.dependencies;
      if (this.stepTwoForm.controls['checked'].value) {
        this.quoteService.quoteModel.dependentCountOver65 = this.dependenciesOlder;
      }
      this.onNextStep.emit(this.currentStep);
    }
  }

  /** Rebote discreto de la fila de dependientes al completar la fecha de nacimiento */
  nudgeDependents: boolean = false;
  private nudgeShown: boolean = false;
  private checkBirthdateNudge(): void {
    if (this.nudgeShown || this.dependencies > 0) { return; }
    const d = Number(this.stepTwoForm.controls['selectedDay'].value);
    const m = Number(this.stepTwoForm.controls['monthSelected'].value);
    const y = String(this.stepTwoForm.controls['yearSelected'].value || '');
    const complete = d >= 1 && d <= 31 && m >= 1 && m <= 12 && /^\d{4}$/.test(y) && Number(y) >= 1900 && Number(y) <= this.lastYear;
    if (!complete) { return; }
    this.nudgeShown = true;
    setTimeout(() => {
      this.nudgeDependents = true;
      setTimeout(() => { this.nudgeDependents = false; }, 1400);
    }, 350);
  }

  createForm() {
    this.stepTwoForm = this.fb.group({
      selectedDay: [null, [Validators.required, Validators.min(1), Validators.max(31), Validators.pattern(/^[0-9]*$/)]],
      monthSelected: [null, [Validators.required, Validators.min(1), Validators.max(12), Validators.pattern(/^[0-9]*$/)]],
      yearSelected: [null, [Validators.required, Validators.min(1900), Validators.max(this.lastYear), Validators.pattern(/^[0-9]*$/)]],
      checked: [false]
    });
  }

  prevStep(): void {
    this.quoteService.fromStepTwo = true
    this.onPrevStep.emit(this.currentStep);
  }

  allowOnlyNumbers(event: Event): void {
    const inputElement = event.target as HTMLInputElement;
    inputElement.value = inputElement.value.replace(/[^0-9]/g, '');
  }

  ngOnInit() {
    this.loadDays();
    this.loadMonth();
    this.loadYears();
    let today = new Date();
    this.minDate.setFullYear(today.getFullYear() - 80);
    this.maxDate.setFullYear(today.getFullYear() - 18);

    const self = this;

    if (this.quoteService?.quoteModel) {

      if (this.quoteService.quoteModel?.applicantBirthdate) {
        this.initializeBirthDate()
      }

      if (this.quoteService.quoteModel.members && this.quoteService.quoteModel.members.length > 0) {
        const date = this.quoteService.quoteModel.members[0].birthdate
        if (date) {
          this.stepTwoForm.controls['selectedDay'].setValue(new Date(date).getDate())
          this.stepTwoForm.controls['monthSelected'].setValue(new Date(date).getMonth() + 1)
          this.stepTwoForm.controls['yearSelected'].setValue(new Date(date).getFullYear())
        }
      }

      if (this.quoteService.quoteModel?.dependentCount
        && this.quoteService.quoteModel?.dependentCount > 0) {
        for (let i = 0; i < this.quoteService.quoteModel.dependentCount; i++) {
          this.addDependencies();
        }
      }

      if (this.quoteService.quoteModel?.dependentCountOver65
        && this.quoteService.quoteModel?.dependentCountOver65 > 0) {

        setTimeout(() => { this.stepTwoForm.controls['checked'].setValue(true) }, 100);

        for (let i = 0; i < this.quoteService.quoteModel.dependentCountOver65; i++) {
          this.addDependenciesOlder();
        }
      }
    }

    // Check for birthdate errors from step 3
    this.checkForBirthdateErrors();
  }

  /**
   * Check for birthdate errors and highlight fields if needed
   */
  private checkForBirthdateErrors(): void {
    const lastError = this.quoteService.getLastError();
    
    if (lastError && lastError.fieldName === 'birthdate' && lastError.shouldHighlight) {
      console.log('🔍 Birthdate error detected, highlighting fields...');
      
      // Show error message
      this.showBirthdateError(lastError.message);
      
      // Highlight birthdate fields
      this.highlightBirthdateFields();
      
      // Clear the error after handling
      this.quoteService.clearLastError();
    }
  }

  /**
   * Show birthdate error message
   */
  private showBirthdateError(message: string): void {
    // You can implement this to show an error message above the form
    console.log('🔍 Birthdate error message:', message);
    
    // For now, we'll just log it. You can add a toast notification or error banner here
  }

  /**
   * Highlight birthdate fields with error styling
   */
  private highlightBirthdateFields(): void {
    // Set the error flag to highlight all birthdate fields
    this.hasBirthdateError = true;
    
    // Auto-remove the error highlighting after 3 seconds
    setTimeout(() => {
      this.hasBirthdateError = false;
    }, 3000);
    
    // Scroll to the birthdate section
    const birthdateSection = document.querySelector('.form-section');
    if (birthdateSection) {
      birthdateSection.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  }

  initializeBirthDate(): void {

    if (this.birthdayInitialized) {
      return;
    }
    this.birthdayInitialized = true;

    if (this.quoteService?.quoteModel?.applicantBirthdate) {
      this.birthDates = this.quoteService.ensureDate(this.quoteService.quoteModel.applicantBirthdate);
      console.log("pre-settled date: ", this.birthDates);
      this.stepTwoForm.controls['selectedDay'].setValue(this.birthDates.getDate())
      this.stepTwoForm.controls['monthSelected'].setValue(this.birthDates.getMonth() + 1)
      this.stepTwoForm.controls['yearSelected'].setValue(this.birthDates.getFullYear())
      return;
    }
    console.log("initialized!!!");
  }

  private calculateAge(birthDate: Date): number {
    const today = new Date();
    let age = today.getFullYear() - birthDate.getFullYear();
    const m = today.getMonth() - birthDate.getMonth();
    if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
      age--;
    }
    return age;
  }



  get canContinue(): boolean {
    // if(this.daySelected && this.monthSelected && this.yearSelected){
    //   this.birthDates = new Date(this.yearSelected, this.monthSelected - 1, this.daySelected);
    //   return (this.birthDates && this.birthDates >= this.minDate && this.birthDates <= this.maxDate);
    // } 
    return false;
  }

  addDependencies() {
    this.dependencies += 1;
  }

  lessDependencies() {
    if (this.dependencies > 0) {
      this.dependencies -= 1;
      if (this.dependenciesOlder > this.dependencies) {
        this.dependenciesOlder = this.dependencies; // nunca mas mayores de 65 que dependientes
      }
    }
  }

  addDependenciesOlder() {
    if (this.dependenciesOlder < this.dependencies) {
      this.dependenciesOlder += 1;
    }
  }

  lessDependenciesOlder() {
    if (this.dependenciesOlder > 0) {
      this.dependenciesOlder -= 1;
    }
  }

  loadDays(totalDays: number = 31, isLeap: boolean = false) {
    // if((isLeap || (this.yearSelected % 4) == 0) && this.monthSelected == 2){
    //   totalDays = 29;
    // }
    for (let index = 1; index <= totalDays; index++) {
      this.days.push(index);
    }

    // if(this.daySelected > totalDays){
    //   this.daySelected = null
    // }
  }
  loadMonth() {
    for (let index = 1; index <= 12; index++) {
      this.months.push(index);
    }
  }

  loadYears() {
    const currentYear: number = new Date().getFullYear();
    const startYear: number = currentYear - 80;
    const endYear: number = currentYear - 18;
    for (let index = startYear; index <= endYear; index++) {
      this.years.push(index);
    }
  }

  monthChange() {
    // if(this.monthSelected == 1 || this.monthSelected == 3 || this.monthSelected == 5 || this.monthSelected == 7 || 
    //   this.monthSelected == 8 || this.monthSelected == 10 || this.monthSelected == 12){
    //     this.loadDays(31)
    // } else if(this.monthSelected == 2) {
    //   this.loadDays(28)
    // } else {
    //   this.loadDays(30)
    // }
  }

  //   yearChange(){
  //     if((this.yearSelected % 4) == 0 ){
  //       this.loadDays(this.daySelected, true)
  //     }
  //     this.loadDays(this.daySelected, false)
  //   }
}
